import React from 'react';
import classnames from 'classnames';
import { map, size, fromPairs, get, isEqual, isArray } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { SingleSelect } from 'modules/singleSelect';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { orderToDo as OrderToDo } from 'ui/views/widgets/orderToDo';
 *
 * // render
 * <OrderToDo propName='propValue'/>
 */
export const orderToDo = ( props ) => {

    return (
        <div className='ui-order-to-do'>

            {/* header */}
            <div className='ui-order-to-do__header'>

                { /* title for the modal */ }
                <div className='ui-order-to-do__header__title'>
                    { getLabel( props.title ) }
                </div>

                { /* close button */ }
                <div
                    className='ui-error-overlay__head__close'
                    onClick={ () => props.closeOverlay() }
                >
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>
            </div>

            {/* body */}
            <div className='ui-order-to-do__body'>

                <div className='ui-order-to-do__body__static'>
                    { map( props.staticFields, field => {

                        const value = props.state[ field.name ];

                        return(
                            <div key={ field.name } className='ui-order-to-do__body__static__field'>
                                <div className='ui-order-to-do__body__static__field__label'> { getLabel( field.title ) } </div>
                                <div className='ui-order-to-do__body__static__field__value'>{ isArray( value ) ? value.join( ', ' ): value } </div>
                            </div>
                        );
                    } ) }
                </div>

                {/* select field view */}
                { map( props.fields, ( field, index ) => {

                    if( 0 === size( props.options[ field.options ] ) ) {
                        return null;
                    }

                    return (
                        <div className='ui-order-to-do__body__select' key={ field.name } >
                            <div className='ui-order-to-do__body__select__title'>
                                { getLabel( field.title ) }
                                {
                                    get( field, 'config.required' ) ? (
                                        <div className='ui-order-to-do__body__select__title__asterisk'>*</div>
                                    ) : null
                                }
                            </div>
                            <SingleSelect
                                key={ index }
                                className = { 'ui-order-to-do__body__select__field' }
                                options={ props.options[ field.options ] }
                                value={ props.filterValues[ index ] }
                                onChange={ ( { value } ) => props.onFilterChange( { name: field.name, value } ) }
                            />
                           
                        </div>
                    );
                } ) }
                {/* select field view */}

                <Form
                    fields={ fromPairs( map( props.formFields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.state.values } // default values
                    isValid={ false }
                    mode='form'
                    key={ size( props.formFields ) }

                    // onChangeCallBack={ props.onChangeCallBack }
                    // updatFieldsOnChange={ true }
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            props.onFormSubmit( values );
                        }
                    } }
                >
                    { ( { fields, values, /*isValid,*/ errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-order-to-do__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {

                                    // if( get( field, 'config.hide' ) ) {
                                    //     return null;
                                    // }

                                    const fieldClassName = classnames( 'ui-order-to-do__body__form__field', `ui-order-to-do__body__form__${field.name}` );
   
                                    return (
                                        <field.view
                                            className={ fieldClassName }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props.formData.options, field.options ) }
                                            allowFilter={ 'state' === field.name }
                                            config={ field.config }
                                            subFields={ props.subFields }
                                            optionsList={ props.options }
                                        />
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='ui-order-to-do__body__form__actions'>
                                    { map( props.actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }

                                                disabled={ 'cancel' !== action.name && 0 === size( props.formFields ) ? true : false }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='large'
                                                className='ui-order-to-do__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => {

                                                    // popover.close();
                                                    props.onCancelClick();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
            </div>
        </div>
    );
};

// set display name
orderToDo.displayName = 'orderToDo';

// set default props
orderToDo.defaultProps = {};

// prop types
orderToDo.propTypes = {};
